/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataReturnOrderItem
 */
export interface NodataReturnOrderItem {
    /**
     * 搜索返回的历史商品ID
     * @type {number}
     * @memberof NodataReturnOrderItem
     */
    goodsId: number;
    /**
     * 返送数量，正整数
     * @type {number}
     * @memberof NodataReturnOrderItem
     */
    quantity: number;
}

/**
 * Check if a given object implements the NodataReturnOrderItem interface.
 */
export function instanceOfNodataReturnOrderItem(value: object): value is NodataReturnOrderItem {
    if (!('goodsId' in value) || value['goodsId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function NodataReturnOrderItemFromJSON(json: any): NodataReturnOrderItem {
    return NodataReturnOrderItemFromJSONTyped(json, false);
}

export function NodataReturnOrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataReturnOrderItem {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'],
        'quantity': json['quantity'],
    };
}

export function NodataReturnOrderItemToJSON(json: any): NodataReturnOrderItem {
    return NodataReturnOrderItemToJSONTyped(json, false);
}

export function NodataReturnOrderItemToJSONTyped(value?: NodataReturnOrderItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'quantity': value['quantity'],
    };
}

